import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationPublishPage } from '@/features/marketPromotion/pages/DonationPublishPage';
import { donationBatchSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/publish-panel')({
  validateSearch: donationBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Publish Panel">
      <Suspense fallback={<PageLoader />}>
        <DonationPublishPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
